<div class="auth-wrapper">
  <div class="auth-shade d-flex align-items-center justify-content-center">
    <div class="login-content p-4">
      <mat-card class="login-card setup-mfa-card" appearance="outlined">
        <mat-card-header class="login-header">
          <div class="logo-section mb-2">
            <img src="../../../assets/images/logo.svg" alt="BellaStudio">
            <span class="ms-2 fs-18 pt-2 fw-medium">BellaStudio</span> 
          </div>
        </mat-card-header>

        <mat-card-content class="login-form-container">
          <div class="setup-mfa-content">
            <!-- Header -->
            <div class="setup-header text-center mb-4">
              <mat-icon class="setup-icon fs-48" color="primary">security</mat-icon>
              <h2 class="auth-title fs-24 fw-medium my-3">Setup Multi-Factor Authentication</h2>
              <p class="auth-description fs-14 mb-0">
                Secure your account by setting up two-factor authentication
              </p>
            </div>

            <!-- Step 1: Download App -->
            <div class="setup-step mb-4">
              <div class="step-header d-flex align-items-center mb-2">
                <div class="step-number mt-3">1</div>
                <h3 class="step-title fs-16 fw-semibold mb-0 ms-2">Download Authenticator App</h3>
              </div>
              <p class="step-description fs-14 ms-5">
                Install an authenticator app on your mobile device:
              </p>
              <!-- <div class="app-links d-flex gap-3 ms-5">
                <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" 
                   target="_blank" 
                   class="app-link">
                  <img src="../../../assets/images/google-play.svg" alt="Google Play" class="app-badge">
                </a>
                <a href="https://apps.apple.com/app/google-authenticator/id388497605" 
                   target="_blank" 
                   class="app-link">
                  <img src="../../../assets/images/app-store.svg" alt="App Store" class="app-badge">
                </a>
              </div> -->
            </div>

            <!-- Step 2: Scan QR Code -->
            <div class="setup-step mb-4">
              <div class="step-header d-flex align-items-center mb-2">
                <div class="step-number mt-3">2</div>
                <h3 class="step-title fs-16 fw-semibold mb-0 ms-2">Scan QR Code</h3>
              </div>
              <p class="step-description fs-14 ms-5 mb-3">
                Open your authenticator app and scan this QR code:
              </p>
              
              <!-- QR Code Display -->
              <div class="qr-code-container d-flex justify-content-center align-items-center mb-3">
                <div class="qr-code-wrapper" *ngIf="qrCodeUrl">
                  <img [src]="qrCodeUrl" alt="MFA QR Code" class="qr-code-image">
                </div>
                <div class="qr-code-loading" *ngIf="!qrCodeUrl">
                  <mat-spinner diameter="40"></mat-spinner>
                  <p class="fs-12 mt-2 text-muted">Loading QR Code...</p>
                </div>
              </div>

              <!-- Manual Entry Option -->
              <div class="manual-entry-hint text-center">
                <p class="fs-12 text-muted">
                  Can't scan? You can manually enter the code in your app
                </p>
              </div>
            </div>

            <!-- Step 3: Setup Button -->
            <div class="setup-step">
              <div class="step-header d-flex align-items-center mb-2">
                <div class="step-number mt-3">3</div>
                <h3 class="step-title fs-16 fw-semibold mb-0 ms-2">Complete Setup</h3>
              </div>
              <p class="step-description fs-14 ms-5 mb-3">
                After scanning the QR code, click the button below to verify your setup
              </p>
              
              <div class="setup-actions ms-5">
                <button 
                  type="button"
                  class="setup-button auth-btn fs-14 fw-semibold"
                  [disabled]="!qrCodeUrl"
                  (click)="proceedToVerification()">
                  <div class="button-content">
                    <mat-icon class="me-1">check_circle</mat-icon>
                    <span>Continue to Verification</span>
                  </div>
                </button>

                <!-- <button 
                  type="button"
                  class="skip-button mt-3 fs-14 auth-btn fw-semibold"
                  (click)="skipSetup()">
                  Setup 
                </button> -->
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    
    <!-- Footer Links -->
    <div class="d-flex justify-content-center mt-auto mb-0 navi-link">
      <a  class="fs-12">Terms of Service</a>
      <a  class="fs-12">Privacy Policy</a>
      <a  class="fs-12">Cookie Policy</a>
    </div>
  </div>
</div>
